import * as Sentry from '@sentry/react';
export const reportToSentry = (message, param)=>{
    let { fingerprint, tags, context } = param;
    Sentry.withScope((scope)=>{
        if (tags) scope.setTags(tags);
        if (context) {
            Object.entries(context).forEach((param)=>{
                let [key, value] = param;
                scope.setContext(key, value);
            });
        }
        scope.setFingerprint([
            fingerprint
        ]);
        Sentry.captureException(new Error(message));
    });
};
